import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  FileUpload: any;
};

export type AclImportPartInput = {
  participant: Array<AclPartInput>;
};

export type AclLocalizedString = {
  de_DE: Scalars['String'];
  en_GB?: Maybe<Scalars['String']>;
};

/** Bei erfolgreichem Import werden die TeilnehmerEmail sowie das Aktualisierungsdatum zurückgegeben. */
export type AclPart = {
  __typename?: 'AclPart';
  partEmail1?: Maybe<Scalars['String']>;
  partChangeDate?: Maybe<Scalars['DateTime']>;
};

/** Schema eines Teilnehmers */
export type AclPartInput = {
  /** A unique identifier used within Hamburg Messe. */
  partId?: Maybe<Scalars['Int']>;
  /** Defines the source of present data set and indicates as a a matter the quality of given data. */
  partVar?: Maybe<TeilnehmerVariante>;
  /** The exhibitors this participant is affiliated with. */
  corpId?: Maybe<Scalars['Int']>;
  /** An HMC-internal reference, unique for every exhibition. */
  expoCode?: Maybe<Scalars['String']>;
  /** A unique identifier used by a servicepartner of Hamburg Messe. */
  missiononeId?: Maybe<Scalars['Int']>;
  /** A unique identifier used by a servicepartner of Hamburg Messe. */
  fairmateId?: Maybe<Scalars['String']>;
  /** The username of a particpant for social networks. */
  partSocialLogin?: Maybe<Scalars['String']>;
  partImage?: Maybe<Scalars['FileUpload']>;
  /** A profile picture of that participant. */
  partPic?: Maybe<AclParticipantPic>;
  /** A short profile or bio of that participant. */
  partProfile?: Maybe<AclLocalizedString>;
  /** The source where a participant first came from – mainly for internal purposes. */
  partSource?: Maybe<Scalars['String']>;
  /** The gender of that participant, we accept m (male), w (female), d (transsexual) or a (unknown). */
  partGender: TeilnehmerGeschlecht;
  /** Standing or laureateship of the participant, which usually accompanies his or her name. */
  partTitle?: Maybe<Scalars['String']>;
  /** The first – or all names pre name – which the participant uses. */
  partName?: Maybe<Scalars['String']>;
  /** The familiy name of given participant. */
  partSurname: Scalars['String'];
  /** The role the participant occupies within his or her organization. */
  partFunction?: Maybe<Scalars['String']>;
  /** The name of the section the participant works within his or her organization. */
  partDepartment?: Maybe<Scalars['String']>;
  /** An add-on to the address that usually helps the postman to find that participant easier. */
  partAddendum?: Maybe<Scalars['String']>;
  /** The name of the street to adress the participant. */
  partStreet?: Maybe<Scalars['String']>;
  /** The postal code of where the participant is located. */
  partZip?: Maybe<Scalars['String']>;
  /** The city where the exhibitor is located. */
  partCity?: Maybe<Scalars['String']>;
  /** Some more detail for where the participant is located, could be the name of a state within the US for example. */
  partRegion?: Maybe<Scalars['String']>;
  /** The full name of the country where the participant is located. */
  partCountry?: Maybe<Scalars['String']>;
  /** A detail to describe the adress, it’s either private or professional. */
  partAdressType?: Maybe<TeilnehmerAdressTyp>;
  /** The first phone number to reach that participant. */
  partPhone1?: Maybe<Scalars['String']>;
  /** So people know what to expect if you’re reaching out; it’s either professional or private. */
  partPhone1Type?: Maybe<TeilnehmerAdressTyp>;
  /** This tells if the participant wants others to use the associated number primarily. */
  partPhone1TypeMain?: Maybe<Scalars['Boolean']>;
  /** Sometimes an email doesn’t cut it, this number can be used to send an emoji or something elsa at 33.600 bits max. */
  partFax?: Maybe<Scalars['String']>;
  /** A second phone number to reach that participant. */
  partPhone2?: Maybe<Scalars['String']>;
  /** So people know what to expect if you’re reaching out; it’s either professional or private. */
  partPhone2Type?: Maybe<TeilnehmerAdressTyp>;
  /** This tells if the participant wants others to use the associated number primarily. */
  partPhone2TypeMain?: Maybe<Scalars['Boolean']>;
  /** The first email adress of that participant. */
  partEmail1: Scalars['String'];
  /** Tells you what kind of email adress, either professional or private. */
  partEmail1Type?: Maybe<TeilnehmerAdressTyp>;
  /** This tells if a participant wants others to use this adress primarily in case of contact by email. */
  partEmail1TypeMain?: Maybe<Scalars['Boolean']>;
  /** The first email adress of that participant. */
  partEmail2?: Maybe<Scalars['String']>;
  /** Tells you what kind of email adress, either professional or private. */
  partEmail2Type?: Maybe<TeilnehmerAdressTyp>;
  /** This tells if the participant wants others to use the associated number primarily. */
  partEmail2TypeMain?: Maybe<Scalars['Boolean']>;
  /** Some participants offer a website with more information on them. */
  partWeb?: Maybe<Scalars['String']>;
  /** Timestamp of a participant’s registration. */
  partRegDate?: Maybe<Scalars['DateTime']>;
  /** A list of unique identifiers the participant will use or has used to access the expo grounds in Hamburg. */
  partTicketId?: Maybe<Scalars['String']>;
  /** Name of the participant’s employer, in case the participant isn’t attached to a corporation of the platform. */
  partCompany2?: Maybe<Scalars['String']>;
  /** Name of the industry the participant does work in. */
  partIndustry?: Maybe<Scalars['String']>;
  /** A list of themes the participant is interested in. */
  classificationId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Classification of the participant’s job. */
  partProfPosition?: Maybe<TeilnehmerBeruflicheStellung>;
  /** A description of the participant’s area of responsibility. */
  partResponsibility?: Maybe<Scalars['String']>;
  /** This indicated the importance of that participant. */
  partDecisionAuthority?: Maybe<TeilnehmerEntscheidungsbefugnis>;
  /** The role a participant has for a particular exhibition, cf. visitor or salesperson. */
  partAccreditationType?: Maybe<Scalars['String']>;
  /** The kind of tickets the participant has bought. */
  partArticles?: Maybe<Scalars['String']>;
  /** All events the participant is participating in. */
  eventId?: Maybe<Scalars['String']>;
  /** The language the participant prefers in case of contact. */
  partLanguage: Scalars['String'];
  /** The various roles this participant has during exhibitions, cf. Panelist or Visitor. */
  partRole?: Maybe<TeilnehmerRolle>;
  /** The preferred time zone of given participant, use this to adapt or personalize content delivery. */
  partTimezoneOffset?: Maybe<Scalars['Int']>;
  /** Defines whether the user can be contacted or not. */
  partMatchmakingActive?: Maybe<Scalars['Boolean']>;
  /** The participant's contact ids. */
  partContactIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type AclParticipantPic = {
  /** The url to request the partPic of a participant. */
  url: Scalars['String'];
  /** A short description of a partPic’s content; expect the name of the participant.  */
  altText?: Maybe<Scalars['String']>;
  /**
   * Some participants might allow the use of their partPic for a certain period of
   * time; expect the partPic to be not available afterwards.
   */
  expires?: Maybe<Scalars['String']>;
  /** The partPic might have an status attached which you should respect. */
  status?: Maybe<Scalars['String']>;
};

/** Keys for AusstellerContent */
export enum AusstellerContentType {
  /** {"de_DE": "Whitepaper", "en_GB": "Whitepaper"} */
  Whitepaper = 'WHITEPAPER',
  /** {"de_DE": "Präsentation", "en_GB": "Presentation"} */
  Presentation = 'PRESENTATION',
  /** {"de_DE": "Unternehmenspräsentation", "en_GB": "Company Presentation"} */
  CompanyPresentation = 'COMPANY_PRESENTATION',
  /** {"de_DE": "eMagazine", "en_GB": "eMagazine"} */
  EMagazine = 'E_MAGAZINE',
  /** {"de_DE": "Patent", "en_GB": "Patent"} */
  Patent = 'PATENT',
  /** {"de_DE": "Fachartikel", "en_GB": "Scientific Article"} */
  ScientificArticle = 'SCIENTIFIC_ARTICLE',
  /** {"de_DE": "Ausschreibung", "en_GB": "Tender Document"} */
  TenderDocument = 'TENDER_DOCUMENT',
  /** {"de_DE": "Nations Pavillon", "en_GB": "Nations Pavillon"} */
  NationsPavillion = 'NATIONS_PAVILLION'
}

export type Brand = {
  __typename?: 'Brand';
  /** A unique identifier for brands used within the platform. */
  brandId?: Maybe<Scalars['Int']>;
  /** A concise title for the brand to help users understand what it is about. */
  brandName?: Maybe<LocalizedString>;
  /** A long text to get further insights on the brand or service. */
  brandDesc?: Maybe<LocalizedString>;
  /** A universal web adress where the user will fine more on that brand or service. */
  brandRef?: Maybe<LocalizedString>;
  /** One or more pictures to illustrate what the brand or services is about. */
  brandLogo?: Maybe<Array<Maybe<BrandPic>>>;
  /** The products this brand or service is associated with. */
  product?: Maybe<Array<Maybe<Product>>>;
  /** All types of classification used as meta information to structure and describe the brand or services. */
  classification?: Maybe<Array<Maybe<Classification>>>;
  /** The producer or provider of this brand or service. */
  corporation?: Maybe<Corp>;
  expoSiteLink?: Maybe<LocalizedString>;
};


export type BrandBrandLogoArgs = {
  size?: Maybe<Array<Maybe<BrandLogoSize>>>;
};

/**
 * Keys for BrandLogoSize, Default-Value is 120x120px:
 * S72x72 = 72 x 72
 * S120x120 = 120 x 120
 * S144x144 = 144 x 144
 * S200x200 = 200 x 200
 * S240x240 = 240 x 240
 * S309x216 = 309 x 216
 * S309x309 = 309 x 309
 * S309x580 = 309 x 580
 * S350x350 = 350 x 350
 * S370x260 = 370 x 260
 * S480x480 = 480 x 480
 * S600x600 = 600 x 600
 * S618x432 = 618 x 432
 * S618x618 = 618 x 618
 * S618x824 = 618 x 824
 * S618x1160 = 618 x 1160
 * S700x700 = 700 x 700
 * S800x560 = 800 x 560
 * S1000x700 = 1000 x 700
 */
export enum BrandLogoSize {
  /** 72x72px */
  S72x72 = 'S72x72',
  /** 120x120px */
  S120x120 = 'S120x120',
  /** 144x144px */
  S144x144 = 'S144x144',
  /** 200x200px */
  S200x200 = 'S200x200',
  /** 240x240px */
  S240x240 = 'S240x240',
  /** 309x216px */
  S309x216 = 'S309x216',
  /** 309x309px */
  S309x309 = 'S309x309',
  /** 309x580px */
  S309x580 = 'S309x580',
  /** 350x350px */
  S350x350 = 'S350x350',
  /** 370x260px */
  S370x260 = 'S370x260',
  /** 480x480px */
  S480x480 = 'S480x480',
  /** 600x600px */
  S600x600 = 'S600x600',
  /** 618x432px */
  S618x432 = 'S618x432',
  /** 618x618px */
  S618x618 = 'S618x618',
  /** 618x824px */
  S618x824 = 'S618x824',
  /** 618x1160px */
  S618x1160 = 'S618x1160',
  /** 700x700px */
  S700x700 = 'S700x700',
  /** 800x560px */
  S800x560 = 'S800x560',
  /** 1000x700px */
  S1000x700 = 'S1000x700'
}

/** Picture */
export type BrandPic = {
  __typename?: 'BrandPic';
  /** The url to request the brandPic of a product. */
  url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  /** A short description of a brandPic’s content; expect the name of the product and some describing text.  */
  altText?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /**
   * Some corporation might allow the use of their brandPic for a certain period of
   * time; expect the brandPic to be not available afterwards.
   */
  expires?: Maybe<Scalars['String']>;
};

export type Chat = {
  __typename?: 'Chat';
  sessionId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/**
 * Die Hamburg Messe – wie alle Messeveranstalter – beschreiben den Umfang
 * sowie das Angebot mit verschiedenen Kategorien und dem Ziel die Orientierung der
 * Teilnehmer zu unterstützen.
 */
export type Classification = {
  __typename?: 'Classification';
  /** A unique identifier for every classification. */
  classificationId?: Maybe<Scalars['Int']>;
  /** A title for humans to understand what this classification is all about. */
  classificationTitle?: Maybe<LocalizedString>;
  /** A quick summary how this type of classification helps participants to navigate an exhibition. */
  classificationDesc?: Maybe<LocalizedString>;
  /**
   * Often exhibitons use a lot of words to describe the same; here we try to
   * explain and summarize this for that type of classification
   */
  classificationOther?: Maybe<Scalars['String']>;
  /**
   * There are several ways to classify exhibitors, products et al; this attribute
   * explains the type of classification. We offer “Product Category”,
   * “Nation Pavilion”, “Special Show”, “Supply Area”, “Vested
   * Interest”, ”Topic” and “Keyword”.
   */
  classificationType?: Maybe<LocalizedString>;
  /** A logo to give that type of classification an identity. */
  classificationIcon?: Maybe<Array<Maybe<ClassificationIcon>>>;
  /**
   * Sometimes a picture tells a thousand words; if available use this to help
   * participants understand what the classification is all about.
   */
  classificationPic?: Maybe<Array<Maybe<ClassificationPic>>>;
  hierarchy?: Maybe<Scalars['String']>;
};


/**
 * Die Hamburg Messe – wie alle Messeveranstalter – beschreiben den Umfang
 * sowie das Angebot mit verschiedenen Kategorien und dem Ziel die Orientierung der
 * Teilnehmer zu unterstützen.
 */
export type ClassificationClassificationIconArgs = {
  size?: Maybe<Array<Maybe<ClassificationSize>>>;
};


/**
 * Die Hamburg Messe – wie alle Messeveranstalter – beschreiben den Umfang
 * sowie das Angebot mit verschiedenen Kategorien und dem Ziel die Orientierung der
 * Teilnehmer zu unterstützen.
 */
export type ClassificationClassificationPicArgs = {
  size?: Maybe<Array<Maybe<ClassificationSize>>>;
};

export type ClassificationIcon = {
  __typename?: 'ClassificationIcon';
  /** The url to request the ClassificationPic. */
  url: Scalars['String'];
  /** The ClassificationPic is offered in various sizes, which can be defined as an argument. */
  size?: Maybe<Scalars['String']>;
  /** A short description of a ClassificationPic’s content; expect the name of the participant. */
  altText?: Maybe<Scalars['String']>;
  /** Expect the ClassificationPic to be not available afterwards. */
  expires?: Maybe<Scalars['String']>;
  /** The ClassificationPic might have an status attached which you should respect. */
  status?: Maybe<Scalars['String']>;
};

export type ClassificationPic = {
  __typename?: 'ClassificationPic';
  /** The url to request the cla ClassificationPic. */
  url: Scalars['String'];
  /** The ClassificationPic is offered in various sizes, which can be defined as an argument. */
  size?: Maybe<Scalars['String']>;
  /** A short description of a ClassificationPic’s content. */
  altText?: Maybe<Scalars['String']>;
  /** Expect the partPic to be not available afterwards. */
  expires?: Maybe<Scalars['String']>;
  /** The ClassificationPic might have an status attached which you should respect. */
  status?: Maybe<Scalars['String']>;
};

/**
 * Keys for ClassificationSize, Default-Value is 120x120px:
 * S72x72 = 72 x 72
 * S80x80 = 80 x 80
 * S100x100 = 100 x 100
 * S120x120 = 120 x 120
 * S144x144 = 144 x 144
 * S160x160 = 160 x 160
 * S200x200 = 200 x 200
 * S240x240 = 240 x 240
 * S400x400 = 400 x 400
 * S480x480 = 480 x 480
 */
export enum ClassificationSize {
  /** 72x72px */
  S72x72 = 'S72x72',
  /** 80x80px */
  S80x80 = 'S80x80',
  /** 100x100px */
  S100x100 = 'S100x100',
  /** 120x120px */
  S120x120 = 'S120x120',
  /** 144x144px */
  S144x144 = 'S144x144',
  /** 160x160px */
  S160x160 = 'S160x160',
  /** 200x200px */
  S200x200 = 'S200x200',
  /** 240x240px */
  S240x240 = 'S240x240',
  /** 400x400px */
  S400x400 = 'S400x400',
  /** 480x480px */
  S480x480 = 'S480x480'
}

/**
 * Keys for ClassificationType, default value is PRODUCTCATEGORY:
 * PRODUCTCATEGORY
 * SPECIALSHOW
 * NATIONPAVILION
 * SUPPLYAREA
 * TOPIC
 * SPELLING
 * KEYWORD
 * VESTED_INTEREST
 */
export enum ClassificationType {
  Productcategory = 'PRODUCTCATEGORY',
  Specialshow = 'SPECIALSHOW',
  Nationpavilion = 'NATIONPAVILION',
  Supplyarea = 'SUPPLYAREA',
  Topic = 'TOPIC',
  Spelling = 'SPELLING',
  Keyword = 'KEYWORD',
  VestedInterest = 'VESTED_INTEREST'
}

export type ContactForm = {
  __typename?: 'ContactForm';
  success?: Maybe<Scalars['Boolean']>;
};

/** Content aus der Plattform */
export type Content = {
  __typename?: 'Content';
  /** A unique identifier for content used within the platform. */
  contentId?: Maybe<Scalars['Int']>;
  /** We support a whole range of content, this attribute tells you the kind of content to expect. */
  contentType: AusstellerContentType;
  /** A concise title for that particular content item. */
  contentTitle: LocalizedString;
  /** A long text to get further insights on the brand. */
  contentDesc?: Maybe<LocalizedString>;
  /** A picture to convey the message of the content */
  contentPic?: Maybe<ContentPic>;
  /** The actual content. */
  contentAttachment?: Maybe<LocalizedString>;
  /** Some content comes with a video, this id requests the stream. */
  contentMediaId?: Maybe<LocalizedString>;
  /** Some content comes with a video, this attribute names teh platform. */
  contentMediaPlatform?: Maybe<LocalizedString>;
  /** An external reference to guide users to in case the want more info regarding that content. */
  contentRef?: Maybe<LocalizedString>;
  /** Timestamp of when the content was updated. */
  contentLastModified?: Maybe<Scalars['DateTime']>;
  /** Timestamp from when this piece of content shall be available via Graph QL. */
  contentAccessibleFrom?: Maybe<Scalars['DateTime']>;
  /** Timestamp from whereafter this piece of content won’t be accessible via Graph QL anymore. */
  contentAccessibleUntil?: Maybe<Scalars['DateTime']>;
  /** Corporations might request data or money in exchange for viewing content. */
  contentChargeable?: Maybe<Scalars['Boolean']>;
  /** The producer or provider of this particular content. */
  corporation?: Maybe<Corp>;
  /** A participant who might have more information for the reader. */
  participant?: Maybe<Part>;
  /** A collection of categories or classifications that describe that particular piece of content. */
  classification?: Maybe<Array<Maybe<Classification>>>;
  expoSiteLink?: Maybe<LocalizedString>;
};


/** Content aus der Plattform */
export type ContentContentPicArgs = {
  size?: Maybe<Array<Maybe<ContentPicSize>>>;
};

/** Picture */
export type ContentPic = {
  __typename?: 'ContentPic';
  /** The url to request the contentPic. */
  url?: Maybe<LocalizedPicString>;
  size?: Maybe<LocalizedPicString>;
  /** A short description of a contentPic’s content; expect the name of the content and some describing text.  */
  altText?: Maybe<LocalizedPicString>;
  status?: Maybe<LocalizedPicString>;
  /**
   * Some corporation might allow the use of their contentPic for a certain period
   * of time; expect the contentPic to be not available afterwards.
   */
  expires?: Maybe<LocalizedPicString>;
};

/**
 * Keys for ContentPicSize, Default-Value is 120x120px:
 * S120x120 = 120 x 120
 * S200x200 = 200 x 200
 * S240x240 = 240 x 240
 * S309x216 = 309 x 216
 * S309x309 = 309 x 309
 * S309x580 = 309 x 580
 * S350x350 = 350 x 350
 * S370x260 = 370 x 260
 * S480x480 = 480 x 480
 * S600x600 = 600 x 600
 * S618x432 = 618 x 432
 * S618x618 = 618 x 618
 * S618x824 = 618 x 824
 * S618x1160 = 618 x 1160
 * S700x700 = 700 x 700
 * S800x560 = 800 x 560
 * S1000x700 = 1000 x 700
 * S1400x1400 = 1400 x 1400
 */
export enum ContentPicSize {
  /** 120x120px */
  S120x120 = 'S120x120',
  /** 200x200px */
  S200x200 = 'S200x200',
  /** 240x240px */
  S240x240 = 'S240x240',
  /** 309x216px */
  S309x216 = 'S309x216',
  /** 309x309px */
  S309x309 = 'S309x309',
  /** 309x580px */
  S309x580 = 'S309x580',
  /** 350x350px */
  S350x350 = 'S350x350',
  /** 370x260px */
  S370x260 = 'S370x260',
  /** 480x480px */
  S480x480 = 'S480x480',
  /** 600x600px */
  S600x600 = 'S600x600',
  /** 618x432px */
  S618x432 = 'S618x432',
  /** 618x618x */
  S618x618 = 'S618x618',
  /** 618x824px */
  S618x824 = 'S618x824',
  /** 618x1160px */
  S618x1160 = 'S618x1160',
  /** 700x700px */
  S700x700 = 'S700x700',
  /** 800x560px */
  S800x560 = 'S800x560',
  /** 1000x700px */
  S1000x700 = 'S1000x700',
  /** 1400x1400px */
  S1400x1400 = 'S1400x1400'
}

/** Aussteller aus der Plattform */
export type Corp = {
  __typename?: 'Corp';
  /** An unique idenitifier for every exhibitor, the id is usable within the platform. */
  corpId?: Maybe<Scalars['Int']>;
  corpChangeDate?: Maybe<Scalars['DateTime']>;
  /** A unique identifier used within Hamburg Messe. */
  addressId?: Maybe<Scalars['String']>;
  /** The way in which every exhibitor is connected to the event; this is either empty or “Sponsor”. */
  corpRole?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventRole?: Maybe<Scalars['String']>;
  /** The name of an exhibitor. */
  corpName?: Maybe<LocalizedString>;
  /** The form of an exhibitor from a legal viewpoint, cf. Inc or Oy. */
  corpLegalStructure?: Maybe<LocalizedString>;
  /** The name of the street where the exhibitor is located. */
  corpStreet?: Maybe<Scalars['String']>;
  /** The postal code of where the exhibitor is located. */
  corpZip?: Maybe<Scalars['String']>;
  /** The city where the exhibitor is located. */
  corpCity?: Maybe<Scalars['String']>;
  /** The name of the country where the exhibitor is located. */
  corpCountry?: Maybe<Scalars['String']>;
  /** The geographic coordinates of the exhibitor’s location, following the Open Location Code (OLC) of Google. */
  corpPlusCode?: Maybe<Scalars['String']>;
  /** The preferred language for communication with the exhibitor. */
  corpLanguage?: Maybe<Scalars['String']>;
  /** The general phone number of the exhibitor, usually the switchboard. */
  corpTel?: Maybe<Scalars['String']>;
  /** A universal number to reach the exhibitor by fax. */
  corpFax?: Maybe<Scalars['String']>;
  /** A universal email adress to reach the exhibitor. */
  corpEmail?: Maybe<Scalars['String']>;
  /** A universal web adress where the exhibitor informs about or advertises itself. */
  corpWeb?: Maybe<LocalizedString>;
  /** A short summary about the exhibitor. */
  corpProfile?: Maybe<LocalizedString>;
  corpLogo?: Maybe<Array<Maybe<CorpLogo>>>;
  /** A classifier for the industry the exhibitor is in, following the eurostat NACE scheme. */
  corpIndustry?: Maybe<Scalars['String']>;
  /** A list of all the brands an exhibitor is known for. */
  corpBrands?: Maybe<Scalars['String']>;
  /** A list of all products the exhibitor offers. */
  corpProducts?: Maybe<Scalars['String']>;
  participant?: Maybe<Array<Maybe<Part>>>;
  stand?: Maybe<Array<Maybe<Stand>>>;
  nomenclature?: Maybe<Nomenclature>;
  classification?: Maybe<Array<Maybe<Classification>>>;
  product?: Maybe<Array<Maybe<Product>>>;
  brand?: Maybe<Array<Maybe<Brand>>>;
  opportunity?: Maybe<Array<Maybe<Opportunity>>>;
  content?: Maybe<Array<Maybe<Content>>>;
  /** The url for the Facebook profile of the corporation. */
  corpSocialFacebook?: Maybe<Scalars['String']>;
  /** The url for the LinkedIn profile of the corporation. */
  corpSocialLinkedin?: Maybe<Scalars['String']>;
  /** The url for the Instagram profile of the corporation. */
  corpSocialInstagram?: Maybe<Scalars['String']>;
  /** The url for the Twitter profile of the corporation. */
  corpSocialTwitter?: Maybe<Scalars['String']>;
  /** The url for the XING profile of the corporation. */
  corpSocialXing?: Maybe<Scalars['String']>;
  expoSiteLink?: Maybe<LocalizedString>;
};


/** Aussteller aus der Plattform */
export type CorpCorpLogoArgs = {
  size?: Maybe<Array<Maybe<CorpLogoSize>>>;
};


/** Aussteller aus der Plattform */
export type CorpParticipantArgs = {
  partRole?: Maybe<TeilnehmerRolle>;
};

export type CorpLogo = {
  __typename?: 'CorpLogo';
  /** The url to request the partPic of a participant. */
  url: Scalars['String'];
  /** The partPic is offered in various sizes, which can be defined as an argument. */
  size?: Maybe<Scalars['String']>;
  /** A short description of a partPic’s content; expect the name of the participant. */
  altText?: Maybe<Scalars['String']>;
  /**
   * Some participants might allow the use of their partPic for a certain period of
   * time; expect the partPic to be not available afterwards.
   */
  expires?: Maybe<Scalars['String']>;
  /** The partPic might have an status attached which you should respect. */
  status?: Maybe<Scalars['String']>;
};

/**
 * Keys for CorpLogoSize, Default-Value is 120x120px:
 * S72x72 = 72 x 72
 * S80x80 = 80 x 80
 * S100x100 = 100 x 100
 * S120x120 = 120 x 120
 * S144x144 = 144 x 144
 * S160x160 = 160 x 160
 * S200x200 = 200 x 200
 * S240x240 = 240 x 240
 * S400x400 = 400 x 400
 * S480x480 = 480 x 480
 */
export enum CorpLogoSize {
  /** 72x72px */
  S72x72 = 'S72x72',
  /** 80x80px */
  S80x80 = 'S80x80',
  /** 100x100px */
  S100x100 = 'S100x100',
  /** 120x120px */
  S120x120 = 'S120x120',
  /** 144x144px */
  S144x144 = 'S144x144',
  /** 160x160px */
  S160x160 = 'S160x160',
  /** 200x200px */
  S200x200 = 'S200x200',
  /** 240x240px */
  S240x240 = 'S240x240',
  /** 400x400px */
  S400x400 = 'S400x400',
  /** 480x480px */
  S480x480 = 'S480x480'
}

/**
 * Keys for CorpType:
 * HA = Hauptaussteller
 * MA = Mitaussteller
 */
export enum CorpType {
  Ha = 'HA',
  Ma = 'MA'
}

/** Aussteller aus der Plattform */
export type Corporation = {
  __typename?: 'Corporation';
  /** An unique idenitifier for every exhibitor, the id is usable within the platform. */
  corpId?: Maybe<Scalars['Int']>;
  corpChangeDate?: Maybe<Scalars['DateTime']>;
  /** A unique identifier used within Hamburg Messe. */
  addressId?: Maybe<Scalars['String']>;
  /** The way in which every exhibitor is connected to the event; this is either empty or “Sponsor”. */
  corpRole?: Maybe<Array<Maybe<Scalars['String']>>>;
  eventRole?: Maybe<Scalars['String']>;
  /** The name of an exhibitor. */
  corpName?: Maybe<LocalizedString>;
  /** The form of an exhibitor from a legal viewpoint, cf. Inc or Oy. */
  corpLegalStructure?: Maybe<LocalizedString>;
  /** The name of the street where the exhibitor is located. */
  corpStreet?: Maybe<Scalars['String']>;
  /** The postal code of where the exhibitor is located. */
  corpZip?: Maybe<Scalars['String']>;
  /** The city where the exhibitor is located. */
  corpCity?: Maybe<Scalars['String']>;
  /** The name of the country where the exhibitor is located. */
  corpCountry?: Maybe<Scalars['String']>;
  /** The geographic coordinates of the exhibitor’s location, following the Open Location Code (OLC) of Google. */
  corpPlusCode?: Maybe<Scalars['String']>;
  /** The preferred language for communication with the exhibitor. */
  corpLanguage?: Maybe<Scalars['String']>;
  /** The general phone number of the exhibitor, usually the switchboard. */
  corpTel?: Maybe<Scalars['String']>;
  /** A universal number to reach the exhibitor by fax. */
  corpFax?: Maybe<Scalars['String']>;
  /** A universal email adress to reach the exhibitor. */
  corpEmail?: Maybe<Scalars['String']>;
  /** A universal web adress where the exhibitor informs about or advertises itself. */
  corpWeb?: Maybe<LocalizedString>;
  /** A short summary about the exhibitor. */
  corpProfile?: Maybe<LocalizedString>;
  corpLogo?: Maybe<Array<Maybe<CorpLogo>>>;
  /** A classifier for the industry the exhibitor is in, following the eurostat NACE scheme. */
  corpIndustry?: Maybe<Scalars['String']>;
  /** A list of all the brands an exhibitor is known for. */
  corpBrands?: Maybe<Scalars['String']>;
  /** A list of all products the exhibitor offers. */
  corpProducts?: Maybe<Scalars['String']>;
  participant?: Maybe<Array<Maybe<Part>>>;
  stand?: Maybe<Array<Maybe<Stand>>>;
  nomenclature?: Maybe<Nomenclature>;
  classification?: Maybe<Array<Maybe<CorporationClassification>>>;
  product?: Maybe<Array<Maybe<Product>>>;
  brand?: Maybe<Array<Maybe<Brand>>>;
  opportunity?: Maybe<Array<Maybe<Opportunity>>>;
  content?: Maybe<Array<Maybe<Content>>>;
  /** The url for the Facebook profile of the corporation. */
  corpSocialFacebook?: Maybe<Scalars['String']>;
  /** The url for the LinkedIn profile of the corporation. */
  corpSocialLinkedin?: Maybe<Scalars['String']>;
  /** The url for the Instagram profile of the corporation. */
  corpSocialInstagram?: Maybe<Scalars['String']>;
  /** The url for the Twitter profile of the corporation. */
  corpSocialTwitter?: Maybe<Scalars['String']>;
  /** The url for the XING profile of the corporation. */
  corpSocialXing?: Maybe<Scalars['String']>;
  expoSiteLink?: Maybe<LocalizedString>;
  experts?: Maybe<Array<Maybe<Part>>>;
  invitedExperts?: Maybe<Array<Maybe<InvitedExpert>>>;
};


/** Aussteller aus der Plattform */
export type CorporationCorpLogoArgs = {
  size?: Maybe<Array<Maybe<CorpLogoSize>>>;
};


/** Aussteller aus der Plattform */
export type CorporationParticipantArgs = {
  partRole?: Maybe<TeilnehmerRolle>;
};

/**
 * Die Hamburg Messe – wie alle Messeveranstalter – beschreiben den Umfang
 * sowie das Angebot mit verschiedenen Kategorien und dem Ziel die Orientierung der
 * Teilnehmer zu unterstützen.
 */
export type CorporationClassification = {
  __typename?: 'CorporationClassification';
  /** A unique identifier for every classification. */
  classificationId?: Maybe<Scalars['Int']>;
  /** A title for humans to understand what this classification is all about. */
  classificationTitle?: Maybe<LocalizedString>;
  /** A quick summary how this type of classification helps participants to navigate an exhibition. */
  classificationDesc?: Maybe<LocalizedString>;
  /**
   * Often exhibitons use a lot of words to describe the same; here we try to
   * explain and summarize this for that type of classification
   */
  classificationOther?: Maybe<Scalars['String']>;
  /**
   * There are several ways to classify exhibitors, products et al; this attribute
   * explains the type of classification. We offer “Product Category”,
   * “Nation Pavilion”, “Special Show”, “Supply Area”, “Vested
   * Interest”, ”Topic” and “Keyword”.
   */
  classificationType?: Maybe<LocalizedString>;
  /** A logo to give that type of classification an identity. */
  classificationIcon?: Maybe<Array<Maybe<ClassificationIcon>>>;
  /**
   * Sometimes a picture tells a thousand words; if available use this to help
   * participants understand what the classification is all about.
   */
  classificationPic?: Maybe<Array<Maybe<ClassificationPic>>>;
  hierarchy?: Maybe<Scalars['String']>;
  expert?: Maybe<Part>;
};


/**
 * Die Hamburg Messe – wie alle Messeveranstalter – beschreiben den Umfang
 * sowie das Angebot mit verschiedenen Kategorien und dem Ziel die Orientierung der
 * Teilnehmer zu unterstützen.
 */
export type CorporationClassificationClassificationIconArgs = {
  size?: Maybe<Array<Maybe<ClassificationSize>>>;
};


/**
 * Die Hamburg Messe – wie alle Messeveranstalter – beschreiben den Umfang
 * sowie das Angebot mit verschiedenen Kategorien und dem Ziel die Orientierung der
 * Teilnehmer zu unterstützen.
 */
export type CorporationClassificationClassificationPicArgs = {
  size?: Maybe<Array<Maybe<ClassificationSize>>>;
};


/** Rahmenprogramm aus der Plattform */
export type Event = {
  __typename?: 'Event';
  /** An unique identifier for every event of the supporting programme. */
  eventId?: Maybe<Scalars['Int']>;
  /** Usually events are part of an exhibition */
  expoCode?: Maybe<Scalars['String']>;
  /** The type of the event, known are “Panel”, “Presentation”, ”Topic” and “Webinar”. */
  eventType?: Maybe<Scalars['String']>;
  /** A title for humans to catch their interest for the event. */
  eventTitle?: Maybe<LocalizedString>;
  /** A short summary of the topics the event is about. */
  eventProfile?: Maybe<LocalizedString>;
  /** The exhibition hall where the event takes place. */
  expoHall?: Maybe<Scalars['String']>;
  /** The event might be part of a sub-conference whose title might help  */
  conferenceTitle?: Maybe<Scalars['String']>;
  /** The identification code of the place where the event takes place. */
  stage?: Maybe<Scalars['String']>;
  /** A collection of external links which support the event, cf. Facebook or Twitter. */
  eventRef?: Maybe<Scalars['String']>;
  /** The day at which the event takes place. */
  eventDay?: Maybe<Scalars['DateTime']>;
  /** The time at which the event starts. */
  eventBegin?: Maybe<Scalars['String']>;
  /** The time at which the event ends. */
  eventFin?: Maybe<Scalars['String']>;
  /** The url which links to the generated ics file */
  eventIcs?: Maybe<LocalizedString>;
  /** Documents related to the event */
  eventDocuments?: Maybe<Array<Maybe<EventDocument>>>;
  /** The allowed number of participants for that particular event. */
  eventPartLimit?: Maybe<Scalars['Int']>;
  /** One or more pictures to illustrate what this event is about. */
  eventPic?: Maybe<Array<Maybe<EventPic>>>;
  /** The id to request media (cf. a video stream) from an external platform. */
  mediaId?: Maybe<Scalars['String']>;
  /** The name of the platform where mediaId is hosted. */
  mediaPlattform?: Maybe<Scalars['String']>;
  /**
   * Details if an event is free of charge to attend (“no”) or if the
   * participants have to pay (“yes”); in case of “yes” make sure to
   * communicate openly.
   */
  eventChargeable?: Maybe<Scalars['Boolean']>;
  /** One or more categories to describe the event. */
  classification?: Maybe<Array<Maybe<Classification>>>;
  /** A unique identifier to request more data on one or more exhibitors connected with the event. */
  corporation?: Maybe<Array<Maybe<Corp>>>;
  /** A unique identifier to request more data on one or more participants attached to the event. */
  participant?: Maybe<Array<Maybe<Part>>>;
  expoSiteLink?: Maybe<LocalizedString>;
};


/** Rahmenprogramm aus der Plattform */
export type EventEventBeginArgs = {
  raw?: Maybe<Scalars['Boolean']>;
};


/** Rahmenprogramm aus der Plattform */
export type EventEventFinArgs = {
  raw?: Maybe<Scalars['Boolean']>;
};


/** Rahmenprogramm aus der Plattform */
export type EventEventPicArgs = {
  size?: Maybe<Array<Maybe<EventPicSize>>>;
};

/** Event related documents */
export type EventDocument = {
  __typename?: 'EventDocument';
  /** The url to request the document of an event. */
  url?: Maybe<Scalars['String']>;
  /** The name of the document. */
  filename?: Maybe<Scalars['String']>;
};

/** Picture */
export type EventPic = {
  __typename?: 'EventPic';
  /** The url to request the eventPic of an event. */
  url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  /** A short description of a eventPic’s content; expect the name of the event and some describing text.  */
  altText?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /**
   * Some event might allow the use of their eventPic for a certain period of time;
   * expect the eventPic to be not available afterwards.
   */
  expires?: Maybe<Scalars['String']>;
};

/**
 * Keys for EventPicSize, Default-Value is 120x120px:
 * S72x72 = 72 x 72
 * S80x80 = 80 x 80
 * S100x100 = 100 x 100
 * S120x120 = 120 x 120
 * S144x144 = 144 x 144
 * S160x160 = 160 x 160
 * S200x200 = 200 x 200
 * S238x120 = 238 x 120
 * S240x240 = 240 x 240
 * S309x216 = 309 x 216
 * S309x309 = 309 x 309
 * S309x412 = 309 x 412
 * S309x580 = 309 x 580
 * S350x350 = 350 x 350
 * S370x260 = 370 x 260
 * S476x240 = 476 x 240
 * S480x480 = 480 x 480
 * S600x600 = 600 x 600
 * S618x432 = 618 x 432
 * S618x618 = 618 x 618
 * S618x824 = 618 x 824
 * S618x1160 = 618 x 1160
 * S800x560 = 800 x 560
 * S1000x700 = 1000 x 700
 */
export enum EventPicSize {
  /** 72x72px */
  S72x72 = 'S72x72',
  /** 80x80px */
  S80x80 = 'S80x80',
  /** 100x100px */
  S100x100 = 'S100x100',
  /** 120x120px */
  S120x120 = 'S120x120',
  /** 144x144px */
  S144x144 = 'S144x144',
  /** 160x160px */
  S160x160 = 'S160x160',
  /** 200x200px */
  S200x200 = 'S200x200',
  /** 238x120px */
  S238x120 = 'S238x120',
  /** 240x240px */
  S240x240 = 'S240x240',
  /** 309x216px */
  S309x216 = 'S309x216',
  /** 309x309px */
  S309x309 = 'S309x309',
  /** 309x412px */
  S309x412 = 'S309x412',
  /** 309x580px */
  S309x580 = 'S309x580',
  /** 350x350px */
  S350x350 = 'S350x350',
  /** 370x260px */
  S370x260 = 'S370x260',
  /** 476x240px */
  S476x240 = 'S476x240',
  /** 480x480px */
  S480x480 = 'S480x480',
  /** 600x600px */
  S600x600 = 'S600x600',
  /** 618x432px */
  S618x432 = 'S618x432',
  /** 618x618px */
  S618x618 = 'S618x618',
  /** S618x824px */
  S618x824 = 'S618x824',
  /** 618x1160px */
  S618x1160 = 'S618x1160',
  /** 800x560px */
  S800x560 = 'S800x560',
  /** 1000x700px */
  S1000x700 = 'S1000x700'
}

export type ExhibitorClassificationInput = {
  classification: Scalars['Int'];
  expert?: Maybe<Scalars['Int']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ExhibitorDeleteInput = {
  classifications?: Maybe<Array<Maybe<ExhibitorClassificationInput>>>;
  experts?: Maybe<Array<Maybe<Scalars['String']>>>;
  classificationExperts?: Maybe<Array<Maybe<ExhibitorClassificationInput>>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ExhibitorInput = {
  classifications?: Maybe<Array<Maybe<ExhibitorClassificationInput>>>;
  experts?: Maybe<Array<Maybe<Scalars['String']>>>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An exhibition from the platform */
export type Expo = {
  __typename?: 'Expo';
  /** An unique identifier for every exhibition. */
  expoId: Scalars['ID'];
  /** The name of the exhibition. */
  expoName: Scalars['String'];
  /** An HMC-internal reference, unique for every exhibition. */
  expoCode: Scalars['String'];
  /** A short summary of what the exhibition is all about. */
  expoDesc: LocalizedString;
  /** The visual reference for that exhibition. */
  expoLogo?: Maybe<Array<Maybe<ExpoLogo>>>;
  /** Name of the city where the exhibtion will take place in its physical form. */
  expoCity: Scalars['String'];
  /** Name of the company which organizes the exhibition. */
  organizer: Scalars['String'];
  /** The first day of the exhibition. */
  expoStart: Scalars['DateTime'];
  /** The last day of the exhibition. */
  expoEnd: Scalars['DateTime'];
  /** This is the email adress of the team that organizes the exhibition. */
  managementEmail: Scalars['String'];
  /** The identification code(s) of all hall(s) the exhibition occupies. */
  expoHall?: Maybe<Scalars['String']>;
  /** This is the address of the website which usually has more information on this particular exhibition. */
  expoWeb?: Maybe<Scalars['String']>;
  /**
   * The first intense communication starts with the participants to onboard them
   * for the exhibition; calculate the date by subtracting this value from
   */
  expoCampaignStart?: Maybe<Scalars['Int']>;
  /** This shows if the exhibition is organized by Hamburg Messe und Congress GmbH. */
  expoHMC: Scalars['Boolean'];
  /** A historical total of people who visited that exhibition in the past which you can use in campaigns or to show off. */
  visitors?: Maybe<Scalars['Int']>;
  /**
   * A historical total of corporations that used this exhibition as a platform to
   * show products or services which you can use in campaigns.
   */
  exhibitors?: Maybe<Scalars['Int']>;
  /**
   * A systemic approach to describe the offerings as well as the content of an
   * exhibition; it is a collection of classifications of the type 'product
   */
  nomenclature?: Maybe<Nomenclature>;
  /** The visual reference fallback for that exhibition. */
  expoFallbackCorpLogo?: Maybe<Array<Maybe<FallbackLogo>>>;
  /** The visual reference fallback for that product */
  expoFallbackProductPic?: Maybe<Array<Maybe<FallbackLogo>>>;
  /** The visual reference fallback for that brand */
  expoFallbackBrandLogo?: Maybe<Array<Maybe<FallbackLogo>>>;
  /** The visual reference fallback for that news */
  expoFallbackNewsPic?: Maybe<Array<Maybe<FallbackLogo>>>;
  /** The visual reference fallback for that content */
  expoFallbackContentPic?: Maybe<Array<Maybe<FallbackLogo>>>;
  /** The visual reference fallback for that participant */
  expoFallbackPartPic?: Maybe<Array<Maybe<FallbackLogo>>>;
  /** The visual reference fallback for that classification pic */
  expoFallbackClassificationPic?: Maybe<Array<Maybe<FallbackLogo>>>;
  /** The visual reference fallback for that classification icon */
  expoFallbackClassificationIcon?: Maybe<Array<Maybe<FallbackLogo>>>;
};


/** An exhibition from the platform */
export type ExpoExpoLogoArgs = {
  size?: Maybe<Array<Maybe<CorpLogoSize>>>;
};


/** An exhibition from the platform */
export type ExpoExpoFallbackCorpLogoArgs = {
  size?: Maybe<Array<Maybe<CorpLogoSize>>>;
};


/** An exhibition from the platform */
export type ExpoExpoFallbackProductPicArgs = {
  size?: Maybe<Array<Maybe<ProdPicSize>>>;
};


/** An exhibition from the platform */
export type ExpoExpoFallbackBrandLogoArgs = {
  size?: Maybe<Array<Maybe<BrandLogoSize>>>;
};


/** An exhibition from the platform */
export type ExpoExpoFallbackNewsPicArgs = {
  size?: Maybe<Array<Maybe<NewsPicSize>>>;
};


/** An exhibition from the platform */
export type ExpoExpoFallbackContentPicArgs = {
  size?: Maybe<Array<Maybe<ContentPicSize>>>;
};


/** An exhibition from the platform */
export type ExpoExpoFallbackPartPicArgs = {
  size?: Maybe<Array<Maybe<ParticipantPicSize>>>;
};


/** An exhibition from the platform */
export type ExpoExpoFallbackClassificationPicArgs = {
  size?: Maybe<Array<Maybe<ContentPicSize>>>;
};


/** An exhibition from the platform */
export type ExpoExpoFallbackClassificationIconArgs = {
  size?: Maybe<Array<Maybe<ContentPicSize>>>;
};

export type ExternalDocument = {
  __typename?: 'ExternalDocument';
  id: Scalars['Int'];
  partId: Scalars['Int'];
  externalUrl: Scalars['String'];
  metaTitle?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  accessDate: Scalars['DateTime'];
};

export type ExternalDocumentPayload = {
  partId: Scalars['Int'];
  externalUrl: Scalars['String'];
  metaTitle?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  accessDate: Scalars['String'];
};

export type ExternalDocumentResponse = {
  __typename?: 'ExternalDocumentResponse';
  id: Scalars['Int'];
  partId: Scalars['Int'];
  externalUrl: Scalars['String'];
  metaTitle?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  accessDate: Scalars['String'];
};

export type FallbackLogo = {
  __typename?: 'FallbackLogo';
  size: Scalars['String'];
  url: Scalars['String'];
  altText?: Maybe<Scalars['String']>;
  expires: Scalars['String'];
  status: Scalars['String'];
};

/** Favourites aus der Plattform */
export type Favourite = {
  __typename?: 'Favourite';
  classification?: Maybe<Array<Maybe<Classification>>>;
  event?: Maybe<Array<Maybe<Event>>>;
  participant?: Maybe<Array<Maybe<Part>>>;
  corporation?: Maybe<Array<Maybe<Corp>>>;
};

/** Input object for favourite a business object */
export type FavouriteMutationInput = {
  elementId: Scalars['Int'];
  partId: Scalars['Int'];
  categoryTag: RecommendationElementType;
  expoCode: Scalars['String'];
};

/** Favourite object response from favourite a business object */
export type FavouriteResponse = {
  __typename?: 'FavouriteResponse';
  favored?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};


export type InvitedExpert = {
  __typename?: 'InvitedExpert';
  email?: Maybe<Scalars['String']>;
};

export type LocalizedPicString = {
  __typename?: 'LocalizedPicString';
  de_DE?: Maybe<Array<Maybe<Scalars['String']>>>;
  en_GB?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type LocalizedString = {
  __typename?: 'LocalizedString';
  de_DE?: Maybe<Scalars['String']>;
  en_GB?: Maybe<Scalars['String']>;
};

/** News aus der Plattform */
export type News = {
  __typename?: 'News';
  newsId?: Maybe<Scalars['Int']>;
  expoCode?: Maybe<Scalars['String']>;
  newsType?: Maybe<Scalars['String']>;
  /** A picture to convey the message of the news. */
  newsPic?: Maybe<Array<Maybe<NewsPic>>>;
  newsTitle?: Maybe<LocalizedString>;
  newsText?: Maybe<LocalizedString>;
  newsAttachment?: Maybe<Array<Maybe<Scalars['String']>>>;
  corpId?: Maybe<Scalars['Int']>;
  eventId?: Maybe<Scalars['Int']>;
  expoSiteLink?: Maybe<LocalizedString>;
};


/** News aus der Plattform */
export type NewsNewsPicArgs = {
  size?: Maybe<Array<Maybe<NewsPicSize>>>;
};

/** Picture */
export type NewsPic = {
  __typename?: 'NewsPic';
  /** The url to request the picture of the news. */
  url?: Maybe<Scalars['String']>;
  /** The newsPic is offered in various sizes, which can be defined as an argument. */
  size?: Maybe<Scalars['String']>;
  /** A short description of a newsPics’s content; expect the name of the news. */
  altText?: Maybe<Scalars['String']>;
  /** The newsPic might have an status attached which you should respect. */
  status?: Maybe<Scalars['String']>;
  /**
   * Some corporations might allow the use of their newsPic for a certain period of
   * time; expect the newsPic to be not available afterwards.
   */
  expires?: Maybe<Scalars['String']>;
};

/**
 * Keys for NewsPicSize, Default-Value is 120x120px:
 * S72x72 = 72 x 72
 * S120x120 = 120 x 120
 * S144x144 = 144 x 144
 * S200x200 = 200 x 200
 * S240x240 = 240 x 240
 * S350x350 = 350 x 350
 * S309x216 = 309 x 216
 * S309x309 = 309 x 309
 * S309x412 = 309 x 412
 * S370x260 = 370 x 260
 * S480x480 = 480 x 480
 * S600x600 = 600 x 600
 * S618x432 = 618 x 432
 * S618x618 = 618 x 618
 * S618x824 = 618 x 824
 * S800x560 = 800 x 560
 * S1000x700 = 1000 x 700
 */
export enum NewsPicSize {
  /** 72x72px */
  S72x72 = 'S72x72',
  /** 120x120px */
  S120x120 = 'S120x120',
  /** 144x144px */
  S144x144 = 'S144x144',
  /** 200x200px */
  S200x200 = 'S200x200',
  /** 240x240px */
  S240x240 = 'S240x240',
  /** 350x350px */
  S350x350 = 'S350x350',
  /** 309x216px */
  S309x216 = 'S309x216',
  /** 309x309px */
  S309x309 = 'S309x309',
  /** 309x412px */
  S309x412 = 'S309x412',
  /** 370x260px */
  S370x260 = 'S370x260',
  /** 480x480px */
  S480x480 = 'S480x480',
  /** 600x600px */
  S600x600 = 'S600x600',
  /** 618x432px */
  S618x432 = 'S618x432',
  /** 618x618px */
  S618x618 = 'S618x618',
  /** 618x824px */
  S618x824 = 'S618x824',
  /** 800x560px */
  S800x560 = 'S800x560',
  /** 1000x700px */
  S1000x700 = 'S1000x700'
}

export type Nomenclature = {
  __typename?: 'Nomenclature';
  classification: Array<Classification>;
};

/** Picture */
export type OppoPic = {
  __typename?: 'OppoPic';
  /** The url to request the oppoPic of an opportunity. */
  url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  /** A short description of a oppoPic’s content; expect the name of the opportunity and some describing text.  */
  altText?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /**
   * Some corporation might allow the use of their oppoPic for a certain period of
   * time; expect the oppoPic to be not available afterwards.
   */
  expires?: Maybe<Scalars['String']>;
};

/**
 * Keys for OppoPicSize, Default-Value is 400x260px:
 * S400x260 = 400 x 260
 * S800x520 = 800 x 520
 */
export enum OppoPicSize {
  /** 400x260px */
  S400x260 = 'S400x260',
  /** 800x520px */
  S800x520 = 'S800x520'
}

export type Opportunity = {
  __typename?: 'Opportunity';
  /** A unique identifier for opportunities used within the platform. */
  oppoId?: Maybe<Scalars['Int']>;
  /** A unique title to attract the curiosity of participants. */
  oppoTitle?: Maybe<LocalizedString>;
  /** A short profile or common description which corporations can use to further advance interest of participants. */
  oppoDesc?: Maybe<LocalizedString>;
  /** An external reference to where the particpants will find the jobs. */
  oppoRef?: Maybe<LocalizedString>;
  /** A unique title used to attract users to follow the reference to gain more insights into opportunities. */
  oppoRefTitle?: Maybe<LocalizedString>;
  /** An external id to get the video from the media platform of  that corporation’s choice. */
  oppoMediaId?: Maybe<LocalizedString>;
  /** The name of the media platform where the video will be requested from. */
  oppoMediaPlatform?: Maybe<LocalizedString>;
  /** One picture to illustrate what the corporation is or cares about. */
  oppoPic?: Maybe<Array<Maybe<OppoPic>>>;
  /** The corporation which advertises its jobs. */
  corporation?: Maybe<Corp>;
};


export type OpportunityOppoPicArgs = {
  size?: Maybe<Array<Maybe<OppoPicSize>>>;
};

/** Teilnehmer aus der Plattform */
export type Part = {
  __typename?: 'Part';
  /** A unique identifier used within Hamburg Messe. */
  partId?: Maybe<Scalars['Int']>;
  /** Timestamp for the last change of the dataset. */
  partLastModified?: Maybe<Scalars['DateTime']>;
  /** An HMC-internal reference, unique for every exhibition. */
  expoCode?: Maybe<Scalars['String']>;
  /** A unique identifier used by a servicepartner of Hamburg Messe. */
  missiononeId?: Maybe<Scalars['Int']>;
  /** A unique identifier used by a servicepartner of Hamburg Messe. */
  fairmateId?: Maybe<Scalars['String']>;
  /** The username of a particpant for social networks. */
  partSocialLogin?: Maybe<Scalars['String']>;
  /** A profile picture of that participant. */
  partPic?: Maybe<Array<Maybe<ParticipantPic>>>;
  /** A short profile or bio of that participant. */
  partProfile?: Maybe<LocalizedString>;
  /** The source where a participant first came from – mainly for internal purposes. */
  partSource?: Maybe<Scalars['String']>;
  /** The gender of that participant, we accept m (male), w (female), d (transsexual) or a (unknown). */
  partGender?: Maybe<Scalars['String']>;
  /** Standing or laureateship of the participant, which usually accompanies his or her name. */
  partTitle?: Maybe<Scalars['String']>;
  /** The first – or all names pre name – which the participant uses. */
  partName?: Maybe<Scalars['String']>;
  /** The familiy name of given participant. */
  partSurname?: Maybe<Scalars['String']>;
  /** The role the participant occupies within his or her organization. */
  partFunction?: Maybe<Scalars['String']>;
  /** The name of the section the participant works within his or her organization. */
  partDepartment?: Maybe<Scalars['String']>;
  /** An add-on to the address that usually helps the postman to find that participant easier. */
  partAddendum?: Maybe<Scalars['String']>;
  /** The name of the street to adress the participant. */
  partStreet?: Maybe<Scalars['String']>;
  /** The postal code of where the participant is located. */
  partZip?: Maybe<Scalars['String']>;
  /** The city where the exhibitor is located. */
  partCity?: Maybe<Scalars['String']>;
  /** Some more detail for where the participant is located, could be the name of a state within the US for example. */
  partRegion?: Maybe<Scalars['String']>;
  /** The full name of the country where the participant is located. */
  partCountry?: Maybe<Scalars['String']>;
  /** A detail to describe the adress, it’s either private or professional. */
  partAdressType?: Maybe<Scalars['String']>;
  /** The first phone number to reach that participant. */
  partPhone1?: Maybe<Scalars['String']>;
  /** So people know what to expect if you’re reaching out; it’s either professional or private. */
  partPhone1Type?: Maybe<Scalars['String']>;
  /** This tells if the participant wants others to use the associated number primarily. */
  partPhone1TypeMain?: Maybe<Scalars['Boolean']>;
  /** Sometimes an email doesn’t cut it, this number can be used to send an emoji or something elsa at 33.600 bits max. */
  partFax?: Maybe<Scalars['String']>;
  /** A second phone number to reach that participant. */
  partPhone2?: Maybe<Scalars['String']>;
  /** So people know what to expect if you’re reaching out; it’s either professional or private. */
  partPhone2Type?: Maybe<Scalars['String']>;
  /** This tells if the participant wants others to use the associated number primarily. */
  partPhone2TypeMain?: Maybe<Scalars['Boolean']>;
  /** The first email adress of that participant. */
  partEmail1?: Maybe<Scalars['String']>;
  /** Tells you what kind of email adress, either professional or private. */
  partEmail1Type?: Maybe<Scalars['String']>;
  /** This tells if a participant wants others to use this adress primarily in case of contact by email. */
  partEmail1TypeMain?: Maybe<Scalars['Boolean']>;
  /** One more email adress to reach that participant. */
  partEmail2?: Maybe<Scalars['String']>;
  /** Tells you what kind of email adress, either professional or private. */
  partEmail2Typ?: Maybe<Scalars['String']>;
  /** Tells, if a participant wants others to use this adress primarily in case of contact by email. */
  partEmail2TypMain?: Maybe<Scalars['Boolean']>;
  /** Some participants offer a website with more information on them. */
  partWeb?: Maybe<Scalars['String']>;
  /** Timestamp of a participant’s registration. */
  partRegDate?: Maybe<Scalars['DateTime']>;
  /** A list of unique identifiers the participant will use or has used to access the expo grounds in Hamburg. */
  partTicketId?: Maybe<Scalars['String']>;
  /** Name of the participant’s employer, in case the participant isn’t attached to a corporation of the platform. */
  partCompany2?: Maybe<Scalars['String']>;
  /** Name of the industry the participant does work in. */
  partIndustry?: Maybe<Scalars['String']>;
  /** A list of themes the participant is interested in. */
  classification?: Maybe<Array<Maybe<Classification>>>;
  /** Classification of the participant’s job. */
  partProfPosition?: Maybe<Scalars['String']>;
  /** A description of the participant’s area of responsibility. */
  partResponsibility?: Maybe<Scalars['String']>;
  /** This indicated the importance of that participant. */
  partDecisionAuthority?: Maybe<Scalars['String']>;
  /** The role a participant has for a particular exhibition, cf. visitor or salesperson. */
  partAccreditationType?: Maybe<Scalars['String']>;
  /** The kind of tickets the participant has bought. */
  partArticles?: Maybe<Scalars['String']>;
  /** The language the participant prefers in case of contact. */
  partLanguage?: Maybe<Scalars['String']>;
  /** The various roles this participant has during exhibitions, cf. Panelist or Visitor. */
  partRole?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The various roles this participant has during exhibitions, cf. Panelist or Visitor. */
  eventRole?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The exhibitors this participant is affiliated with. */
  corporation?: Maybe<Array<Maybe<Corp>>>;
  /** The preferred time zone of given participant, use this to adapt or personalize content delivery. */
  partTimezoneOffset?: Maybe<Scalars['Int']>;
  /** Defines whether the user can be contacted or not. */
  partMatchmakingActive?: Maybe<Scalars['Boolean']>;
  /** The participant's contacts. */
  partContact?: Maybe<Array<Maybe<Part>>>;
  expoSiteLink?: Maybe<LocalizedString>;
};


/** Teilnehmer aus der Plattform */
export type PartPartPicArgs = {
  size?: Maybe<Array<Maybe<ParticipantPicSize>>>;
};

export type ParticipantPic = {
  __typename?: 'ParticipantPic';
  /** The url to request the partPic of a participant. */
  url: Scalars['String'];
  /** The partPic is offered in various sizes, which can be defined as an argument. */
  size?: Maybe<Scalars['String']>;
  /** A short description of a partPic’s content; expect the name of the participant. */
  altText?: Maybe<Scalars['String']>;
  /**
   * Some participants might allow the use of their partPic for a certain period of
   * time; expect the partPic to be not available afterwards.
   */
  expires?: Maybe<Scalars['String']>;
  /** The partPic might have an status attached which you should respect. */
  status?: Maybe<Scalars['String']>;
};

/**
 * Keys for ParticipantPicSize, Default-Value is 120x120px:
 * S72x72 = 72 x 72
 * S80x80 = 80 x 80
 * S100x100 = 100 x 100
 * S120x120 = 120 x 120
 * S144x144 = 144 x 144
 * S160x160 = 160 x 160
 * S160x200 = 160 x 200
 * S240x240 = 240 x 240
 * S320x400 = 320 x 400
 * S280x350 = 280 x 350
 * S560x700 = 560 x 700
 */
export enum ParticipantPicSize {
  /** 72x72px */
  S72x72 = 'S72x72',
  /** 80x80px */
  S80x80 = 'S80x80',
  /** 100x100px */
  S100x100 = 'S100x100',
  /** 120x120px */
  S120x120 = 'S120x120',
  /** 144x144px */
  S144x144 = 'S144x144',
  /** 160x160px */
  S160x160 = 'S160x160',
  /** 160x200px */
  S160x200 = 'S160x200',
  /** 240x240px */
  S240x240 = 'S240x240',
  /** 320x400px */
  S320x400 = 'S320x400',
  /** 280x350px */
  S280x350 = 'S280x350',
  /** 560x700px */
  S560x700 = 'S560x700'
}

export type PlatformMutation = {
  __typename?: 'PlatformMutation';
  participant?: Maybe<Array<Maybe<AclPart>>>;
  updateExhibitor: Corporation;
  externalDocument: ExternalDocumentResponse;
  createMeeting: Termin;
  updateMeeting: Termin;
  favourite: FavouriteResponse;
  requestChatToken?: Maybe<Scalars['String']>;
  contact: ContactForm;
};


export type PlatformMutationParticipantArgs = {
  input: AclImportPartInput;
};


export type PlatformMutationUpdateExhibitorArgs = {
  corpId: Scalars['Int'];
  expoCode: Scalars['String'];
  add?: Maybe<ExhibitorInput>;
  delete?: Maybe<ExhibitorDeleteInput>;
};


export type PlatformMutationExternalDocumentArgs = {
  input: ExternalDocumentPayload;
};


export type PlatformMutationCreateMeetingArgs = {
  input: TerminCreateInput;
};


export type PlatformMutationUpdateMeetingArgs = {
  id: Scalars['Int'];
  input: TerminUpdateInput;
};


export type PlatformMutationFavouriteArgs = {
  input: FavouriteMutationInput;
};


export type PlatformMutationRequestChatTokenArgs = {
  partId: Scalars['Int'];
  uuid: Scalars['String'];
};


export type PlatformMutationContactArgs = {
  subject: Scalars['String'];
  body: Scalars['String'];
  recipient: Scalars['String'];
  sender: Scalars['String'];
  sendCopy: Scalars['Boolean'];
};

export type PlatformQuery = {
  __typename?: 'PlatformQuery';
  externalDocumentList?: Maybe<Array<Maybe<ExternalDocument>>>;
  participant?: Maybe<Array<Maybe<Part>>>;
  meetings?: Maybe<Array<Maybe<Termin>>>;
  meeting?: Maybe<Termin>;
  classification?: Maybe<Array<Maybe<Classification>>>;
  corporation?: Maybe<Array<Maybe<Corp>>>;
  exhibitor?: Maybe<Corporation>;
  favourite?: Maybe<Favourite>;
  brand?: Maybe<Array<Maybe<Brand>>>;
  product?: Maybe<Array<Maybe<Product>>>;
  content?: Maybe<Array<Maybe<Content>>>;
  event?: Maybe<Array<Maybe<Event>>>;
  news?: Maybe<Array<Maybe<News>>>;
};


export type PlatformQueryExternalDocumentListArgs = {
  partId: Scalars['Int'];
};


export type PlatformQueryParticipantArgs = {
  expoCode: Scalars['String'];
  partId?: Maybe<Scalars['Int']>;
  partLastModifiedAfter?: Maybe<Scalars['DateTime']>;
  currentUser?: Maybe<Scalars['Boolean']>;
};


export type PlatformQueryMeetingsArgs = {
  partId: Scalars['Int'];
};


export type PlatformQueryMeetingArgs = {
  uuid: Scalars['String'];
};


export type PlatformQueryClassificationArgs = {
  classificationType?: Maybe<Array<Maybe<ClassificationType>>>;
  classificationTitle?: Maybe<Scalars['String']>;
};


export type PlatformQueryCorporationArgs = {
  expoCode: Scalars['String'];
  corpId?: Maybe<Scalars['Int']>;
};


export type PlatformQueryExhibitorArgs = {
  expoCode: Scalars['String'];
  corpId: Scalars['Int'];
};


export type PlatformQueryFavouriteArgs = {
  partId: Scalars['Int'];
  expoCode: Scalars['String'];
};


export type PlatformQueryBrandArgs = {
  brandId?: Maybe<Scalars['Int']>;
};


export type PlatformQueryProductArgs = {
  expoCode?: Maybe<Scalars['String']>;
  prodId?: Maybe<Scalars['Int']>;
};


export type PlatformQueryContentArgs = {
  contentId?: Maybe<Scalars['Int']>;
  contentType?: Maybe<Scalars['String']>;
  corpId?: Maybe<Scalars['Int']>;
  classificationTitle?: Maybe<Scalars['String']>;
};


export type PlatformQueryEventArgs = {
  eventId?: Maybe<Scalars['Int']>;
  expoCode?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  eventDay?: Maybe<Scalars['DateTime']>;
};


export type PlatformQueryNewsArgs = {
  newsId?: Maybe<Scalars['Int']>;
  newsType?: Maybe<Scalars['String']>;
  expoCode?: Maybe<Scalars['String']>;
  corpId?: Maybe<Scalars['Int']>;
};

/** Picture */
export type ProdPic = {
  __typename?: 'ProdPic';
  /** The url to request the prodPic of a product. */
  url?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  /** A short description of a prodPic’s content; expect the name of the product and some describing text.  */
  altText?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /**
   * Some corporation might allow the use of their prodPic for a certain period of
   * time; expect the prodPic to be not available afterwards.
   */
  expires?: Maybe<Scalars['String']>;
};

/**
 * Keys for ProductPicSize, Default-Value is 120x120px:
 * S120x120 = 120 x 120
 * S200x200 = 200 x 200
 * S240x240 = 240 x 240
 * S309x216 = 309 x 216
 * S309x309 = 309 x 309
 * S309x580 = 309 x 580
 * S350x350 = 350 x 350
 * S370x260 = 370 x 260
 * S600x600 = 600 x 600
 * S618x432 = 618 x 432
 * S618x618 = 618 x 618
 * S618x824 = 618 x 824
 * S618x1160 = 618 x 1160
 * S700x700 = 700 x 700
 * S800x560 = 800 x 560
 * S1000x700 = 1000 x 700
 * 1400x1400 = 1400 x 1400
 */
export enum ProdPicSize {
  /** 120x120px */
  S120x120 = 'S120x120',
  /** 200x200px */
  S200x200 = 'S200x200',
  /** 240x240px */
  S240x240 = 'S240x240',
  /** 309x216px */
  S309x216 = 'S309x216',
  /** 309x309px */
  S309x309 = 'S309x309',
  /** 309x580px */
  S309x580 = 'S309x580',
  /** 350x350px */
  S350x350 = 'S350x350',
  /** 370x260px */
  S370x260 = 'S370x260',
  /** 600x600px */
  S600x600 = 'S600x600',
  /** 618x432px */
  S618x432 = 'S618x432',
  /** 618x618px */
  S618x618 = 'S618x618',
  /** 618x824px */
  S618x824 = 'S618x824',
  /** 618x1160px */
  S618x1160 = 'S618x1160',
  /** 700x700px */
  S700x700 = 'S700x700',
  /** 800x560px */
  S800x560 = 'S800x560',
  /** 1000x700px */
  S1000x700 = 'S1000x700',
  /** 1400x1400px */
  S1400x1400 = 'S1400x1400'
}

export type Product = {
  __typename?: 'Product';
  /** A unique identifier for products used within the platform. */
  prodId?: Maybe<Scalars['Int']>;
  /** A concise title for the product to help users understand what it is about. */
  prodTitle?: Maybe<LocalizedString>;
  /** A long text to get further insights on the product or service. */
  prodDesc?: Maybe<LocalizedString>;
  /** A universal web adress where the user will fine more on that product or service. */
  prodRef?: Maybe<LocalizedString>;
  /** Signals, if the product or service is new to markets and consumers. */
  prodInnovation?: Maybe<Scalars['Boolean']>;
  /** One or more pictures to illustrate what the product or services is about. */
  prodPic?: Maybe<Array<Maybe<ProdPic>>>;
  /** Some products come with a video, this id requests the stream. */
  prodMediaId?: Maybe<Scalars['String']>;
  /** Some content comes with a video, this attribute names the platform from which the stream can be requested. */
  prodMediaPlatform?: Maybe<Scalars['String']>;
  /** An array of documents to support the message or add further information. */
  prodAttachment?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The brands this product or service is associated with. */
  brand?: Maybe<Array<Maybe<Brand>>>;
  /** All types of classification used as meta information to structure and describe the product or services. */
  classification?: Maybe<Array<Maybe<Classification>>>;
  /** The producer or provider of this product or service. */
  corporation?: Maybe<Corp>;
  expoSiteLink?: Maybe<LocalizedString>;
};


export type ProductProdPicArgs = {
  size?: Maybe<Array<Maybe<ProdPicSize>>>;
};

/**
 * Keys for recommendation element types:
 * EVENT
 * PARTICIPANT
 * CLASSIFICATION
 * CORPORATION
 */
export enum RecommendationElementType {
  Event = 'EVENT',
  Participant = 'PARTICIPANT',
  Classification = 'CLASSIFICATION',
  Corporation = 'CORPORATION'
}

export type Stand = {
  __typename?: 'Stand';
  regiNo?: Maybe<Scalars['Int']>;
  regiNoHA?: Maybe<Scalars['Int']>;
  corpType?: Maybe<CorpType>;
  expoHall?: Maybe<Scalars['String']>;
  standNo?: Maybe<Scalars['String']>;
  products?: Maybe<Scalars['String']>;
  brands?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['String']>;
  corpName?: Maybe<LocalizedString>;
  corpWeb?: Maybe<LocalizedString>;
  corpProfile?: Maybe<LocalizedString>;
  nomenclature?: Maybe<Nomenclature>;
};

/** Keys for TeilnehmerAdressTyp */
export enum TeilnehmerAdressTyp {
  Privat = 'PRIVAT',
  Beruflich = 'BERUFLICH'
}

/** Keys for TeilnehmerBeruflicheStellung */
export enum TeilnehmerBeruflicheStellung {
  /** {"de_DE": "Selbständiger Unternehmer, Mitinhaber, freiberuflich Tätiger", "en_GB": "Entrepreneur, co-owner, freelancer"} */
  UnternehmerFreiberufler = 'UNTERNEHMER_FREIBERUFLER',
  /**
   * {"de_DE": "Geschäftsführer, Vorstandsmitglied, Behördenleiter o. ä.",
   * "en_GB": "Managing director, board member, head of an authority etc."}
   */
  GeschaeftsfuehrerVorstand = 'GESCHAEFTSFUEHRER_VORSTAND',
  /**
   * {"de_DE": "Bereichsleiter, Betriebsleiter, Werksleiter, Filialleiter,
   * Amtsleiter", "en_GB": "Area manager, works manager, plant manager, branch
   * manager, head of public office"}
   */
  BereichsleiterWerksleiterFilialleiter = 'BEREICHSLEITER_WERKSLEITER_FILIALLEITER',
  /** {"de_DE": "Abteilungsleiter, Gruppenleiter, Teamleiter", "en_GB": "Department head, group head, team leader"} */
  AbteilungsleiterGruppenleiterTeamleiter = 'ABTEILUNGSLEITER_GRUPPENLEITER_TEAMLEITER',
  /** {"de_DE": "Anderer Angestellter, Beamter, Facharbeiter", "en_GB": "Department head, group head, team leader"} */
  AngestellterBeamterFacharbeiter = 'ANGESTELLTER_BEAMTER_FACHARBEITER',
  /** {"de_DE": "Dozent, Lehrer", "en_GB": "Lecturer, teacher"} */
  DozentLehrer = 'DOZENT_LEHRER',
  /** {"de_DE": "Auszubildender", "en_GB": "Trainee"} */
  Auszubildender = 'AUSZUBILDENDER',
  /** {"de_DE": "Andere berufliche Stellung", "en_GB": "Other position"} */
  AndereBeruflicheStellung = 'ANDERE_BERUFLICHE_STELLUNG',
  /** {"de_DE": "Schüler/Student", "en_GB": "Student"} */
  SchuelerStudent = 'SCHUELER_STUDENT',
  /** {"de_DE": "Andere nicht Berufstätige", "en_GB": "Other not gainfully employed"} */
  AndereNichtBerufstaetige = 'ANDERE_NICHT_BERUFSTAETIGE'
}

/** Keys for TeilnehmerEntscheidungsbefugnis */
export enum TeilnehmerEntscheidungsbefugnis {
  /** {"de_DE": "Ausschlaggebend", "en_GB": "Decisively"} */
  Ausschlaggebend = 'AUSSCHLAGGEBEND',
  /** {"de_DE": "Mitentscheidend", "en_GB": "Collectively"} */
  Mitentscheidend = 'MITENTSCHEIDEND',
  /** {"de_DE": "Beratend", "en_GB": "In an advisory capacity"} */
  Beratend = 'BERATEND',
  /** {"de_DE": "Nicht beteiligt", "en_GB": "no"} */
  NichtBeteiligt = 'NICHT_BETEILIGT',
  /** {"de_DE": "Schüler/Student", "en_GB": "Student"} */
  SchuelerStudent = 'SCHUELER_STUDENT',
  /** {"de_DE": "Andere nicht Berufstätige", "en_GB": "Other not gainfully employed"} */
  AndereNichtBerufstaetige = 'ANDERE_NICHT_BERUFSTAETIGE'
}

/** Keys for TeilnehmerGeschlecht */
export enum TeilnehmerGeschlecht {
  /** {"de_DE": "männlich", "en_GB": "männlich"} */
  M = 'M',
  /** {"de_DE": "female", "en_GB": "female"} */
  W = 'W',
  /** {"de_DE": "inter", "en_GB": "inter"} */
  D = 'D',
  /** {"de_DE": "kein Geschlecht", "en_GB": "unknown"} */
  A = 'A'
}

/**
 * Keys für TeilnehmerRolle, Default-Wert ist WEITERE:
 * EVENTMANAGER = Eventmanager
 * BESUCHER = Besucher
 * STANDMITARBEITER = Standmitarbeiter
 * WEITERE = Weiterer Teilnehmer
 * SPEAKER = Speaker
 * PANELIST = Panelist
 * VIRTUELL = Virtueller Teilnehmer
 * EXPERTE = Experte
 */
export enum TeilnehmerRolle {
  Eventmanager = 'EVENTMANAGER',
  Besucher = 'BESUCHER',
  Weitere = 'WEITERE',
  Standmitarbeiter = 'STANDMITARBEITER',
  Speaker = 'SPEAKER',
  Panelist = 'PANELIST',
  Virtuell = 'VIRTUELL',
  Experte = 'EXPERTE'
}

/** Keys for TeilnehmerVariante */
export enum TeilnehmerVariante {
  /** Defines the source of data as of 'particpant'. */
  Participant = 'PARTICIPANT',
  /** Defines the source of data as of 'exhibitor'. */
  Exhibitor = 'EXHIBITOR',
  /** Defines the source of data as of 'servicepartner'. */
  Servicepartner = 'SERVICEPARTNER'
}

export type Termin = {
  __typename?: 'Termin';
  id: Scalars['Int'];
  uuid: Scalars['String'];
  expo: Expo;
  meetingType: Scalars['String'];
  product?: Maybe<Classification>;
  participant?: Maybe<Part>;
  expert?: Maybe<Part>;
  invitations?: Maybe<Array<Maybe<Scalars['String']>>>;
  participants?: Maybe<Array<Maybe<Part>>>;
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
  hasEnded?: Maybe<Scalars['Boolean']>;
  request?: Maybe<Scalars['String']>;
  document?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  chat?: Maybe<Chat>;
  corporation: Corp;
};

export type TerminCreateInput = {
  expo: Scalars['String'];
  meetingType: Scalars['String'];
  document?: Maybe<Scalars['FileUpload']>;
  product: Scalars['Int'];
  corporation: Scalars['Int'];
  participant: Scalars['Int'];
  expert: Scalars['Int'];
  participants?: Maybe<Array<Maybe<Scalars['String']>>>;
  invitations?: Maybe<Array<Maybe<Scalars['String']>>>;
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  hasEnded?: Maybe<Scalars['Boolean']>;
  request?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type TerminUpdateInput = {
  expo?: Maybe<Scalars['String']>;
  meetingType?: Maybe<Scalars['String']>;
  document?: Maybe<Scalars['FileUpload']>;
  product?: Maybe<Scalars['Int']>;
  participant?: Maybe<Scalars['Int']>;
  expert?: Maybe<Scalars['Int']>;
  participants?: Maybe<Array<Maybe<Scalars['String']>>>;
  invitations?: Maybe<Array<Maybe<Scalars['String']>>>;
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  hasEnded?: Maybe<Scalars['Boolean']>;
  request?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type ExpoLogo = {
  __typename?: 'expoLogo';
  size: Scalars['String'];
  url: Scalars['String'];
  altText?: Maybe<Scalars['String']>;
  expires: Scalars['String'];
  status: Scalars['String'];
};

export type FindCorporationQueryVariables = Exact<{
  expoCode: Scalars['String'];
  corpId: Scalars['Int'];
}>;


export type FindCorporationQuery = (
  { __typename?: 'PlatformQuery' }
  & { exhibitor?: Maybe<(
    { __typename?: 'Corporation' }
    & CorpFieldsFragment
  )> }
);

export type CorpFieldsFragment = (
  { __typename?: 'Corporation' }
  & Pick<Corporation, 'corpId'>
  & { corpName?: Maybe<(
    { __typename?: 'LocalizedString' }
    & Pick<LocalizedString, 'de_DE' | 'en_GB'>
  )>, corpProfile?: Maybe<(
    { __typename?: 'LocalizedString' }
    & Pick<LocalizedString, 'de_DE' | 'en_GB'>
  )>, classification?: Maybe<Array<Maybe<(
    { __typename?: 'CorporationClassification' }
    & Pick<CorporationClassification, 'classificationId'>
    & { classificationDesc?: Maybe<(
      { __typename?: 'LocalizedString' }
      & Pick<LocalizedString, 'en_GB' | 'de_DE'>
    )>, classificationTitle?: Maybe<(
      { __typename?: 'LocalizedString' }
      & Pick<LocalizedString, 'en_GB' | 'de_DE'>
    )>, expert?: Maybe<(
      { __typename?: 'Part' }
      & Pick<Part, 'partId'>
    )> }
  )>>> }
);

export type CreateMeetingMutationVariables = Exact<{
  input: TerminCreateInput;
}>;


export type CreateMeetingMutation = (
  { __typename?: 'PlatformMutation' }
  & { createMeeting: (
    { __typename?: 'Termin' }
    & Pick<Termin, 'uuid'>
  ) }
);

export type UpdateMeetingMutationVariables = Exact<{
  id: Scalars['Int'];
  input: TerminUpdateInput;
}>;


export type UpdateMeetingMutation = (
  { __typename?: 'PlatformMutation' }
  & { updateMeeting: (
    { __typename?: 'Termin' }
    & TerminFieldsFragment
  ) }
);

export type RequestChatTokenMutationVariables = Exact<{
  partId: Scalars['Int'];
  uuid: Scalars['String'];
}>;


export type RequestChatTokenMutation = (
  { __typename?: 'PlatformMutation' }
  & Pick<PlatformMutation, 'requestChatToken'>
);

export type FindMeetingQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type FindMeetingQuery = (
  { __typename?: 'PlatformQuery' }
  & { meeting?: Maybe<(
    { __typename?: 'Termin' }
    & TerminFieldsFragment
  )> }
);

export type TerminFieldsFragment = (
  { __typename?: 'Termin' }
  & Pick<Termin, 'id' | 'uuid' | 'meetingType' | 'invitations' | 'start' | 'end' | 'hasEnded' | 'request' | 'document' | 'status'>
  & { product?: Maybe<(
    { __typename?: 'Classification' }
    & { classificationTitle?: Maybe<(
      { __typename?: 'LocalizedString' }
      & Pick<LocalizedString, 'en_GB' | 'de_DE'>
    )>, classificationDesc?: Maybe<(
      { __typename?: 'LocalizedString' }
      & Pick<LocalizedString, 'en_GB' | 'de_DE'>
    )> }
  )>, corporation: (
    { __typename?: 'Corp' }
    & Pick<Corp, 'corpId'>
    & { corpName?: Maybe<(
      { __typename?: 'LocalizedString' }
      & Pick<LocalizedString, 'en_GB' | 'de_DE'>
    )> }
  ), participant?: Maybe<(
    { __typename?: 'Part' }
    & PartFieldsFragment
  )>, expert?: Maybe<(
    { __typename?: 'Part' }
    & PartFieldsFragment
  )>, participants?: Maybe<Array<Maybe<(
    { __typename?: 'Part' }
    & PartFieldsFragment
  )>>>, chat?: Maybe<(
    { __typename?: 'Chat' }
    & Pick<Chat, 'sessionId'>
  )> }
);

export type PartFieldsFragment = (
  { __typename?: 'Part' }
  & Pick<Part, 'partId' | 'partTitle' | 'partName' | 'partSurname' | 'partFunction' | 'partDepartment' | 'partProfPosition'>
  & { partProfile?: Maybe<(
    { __typename?: 'LocalizedString' }
    & Pick<LocalizedString, 'de_DE' | 'en_GB'>
  )>, corporation?: Maybe<Array<Maybe<(
    { __typename?: 'Corp' }
    & Pick<Corp, 'corpId'>
    & { corpName?: Maybe<(
      { __typename?: 'LocalizedString' }
      & Pick<LocalizedString, 'de_DE' | 'en_GB'>
    )> }
  )>>>, partPic?: Maybe<Array<Maybe<(
    { __typename?: 'ParticipantPic' }
    & Pick<ParticipantPic, 'url'>
  )>>> }
);

export type CurrentParticipantQueryVariables = Exact<{
  expoCode: Scalars['String'];
}>;


export type CurrentParticipantQuery = (
  { __typename?: 'PlatformQuery' }
  & { participant?: Maybe<Array<Maybe<(
    { __typename?: 'Part' }
    & ParticipantFieldsFragment
  )>>> }
);

export type ParticipantFieldsFragment = (
  { __typename?: 'Part' }
  & Pick<Part, 'partId'>
);

export const CorpFieldsFragmentDoc = gql`
    fragment CorpFields on Corporation {
  corpId
  corpName {
    de_DE
    en_GB
  }
  corpProfile {
    de_DE
    en_GB
  }
  classification {
    classificationId
    classificationDesc {
      en_GB
      de_DE
    }
    classificationTitle {
      en_GB
      de_DE
    }
    expert {
      partId
    }
  }
}
    `;
export const PartFieldsFragmentDoc = gql`
    fragment PartFields on Part {
  partId
  partProfile {
    de_DE
    en_GB
  }
  partTitle
  partName
  partSurname
  corporation {
    corpId
    corpName {
      de_DE
      en_GB
    }
  }
  partFunction
  partDepartment
  partProfPosition
  partPic {
    url
  }
}
    `;
export const TerminFieldsFragmentDoc = gql`
    fragment TerminFields on Termin {
  id
  uuid
  meetingType
  product {
    classificationTitle {
      en_GB
      de_DE
    }
    classificationDesc {
      en_GB
      de_DE
    }
  }
  corporation {
    corpId
    corpName {
      en_GB
      de_DE
    }
  }
  participant {
    ...PartFields
  }
  expert {
    ...PartFields
  }
  invitations
  participants {
    ...PartFields
  }
  start
  end
  hasEnded
  request
  document
  status
  chat {
    sessionId
  }
}
    ${PartFieldsFragmentDoc}`;
export const ParticipantFieldsFragmentDoc = gql`
    fragment ParticipantFields on Part {
  partId
}
    `;
export const FindCorporationDocument = gql`
    query findCorporation($expoCode: String!, $corpId: Int!) {
  exhibitor(expoCode: $expoCode, corpId: $corpId) {
    ...CorpFields
  }
}
    ${CorpFieldsFragmentDoc}`;

/**
 * __useFindCorporationQuery__
 *
 * To run a query within a React component, call `useFindCorporationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCorporationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCorporationQuery({
 *   variables: {
 *      expoCode: // value for 'expoCode'
 *      corpId: // value for 'corpId'
 *   },
 * });
 */
export function useFindCorporationQuery(baseOptions: Apollo.QueryHookOptions<FindCorporationQuery, FindCorporationQueryVariables>) {
        return Apollo.useQuery<FindCorporationQuery, FindCorporationQueryVariables>(FindCorporationDocument, baseOptions);
      }
export function useFindCorporationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCorporationQuery, FindCorporationQueryVariables>) {
          return Apollo.useLazyQuery<FindCorporationQuery, FindCorporationQueryVariables>(FindCorporationDocument, baseOptions);
        }
export type FindCorporationQueryHookResult = ReturnType<typeof useFindCorporationQuery>;
export type FindCorporationLazyQueryHookResult = ReturnType<typeof useFindCorporationLazyQuery>;
export type FindCorporationQueryResult = Apollo.QueryResult<FindCorporationQuery, FindCorporationQueryVariables>;
export const CreateMeetingDocument = gql`
    mutation createMeeting($input: TerminCreateInput!) {
  createMeeting(input: $input) {
    uuid
  }
}
    `;
export type CreateMeetingMutationFn = Apollo.MutationFunction<CreateMeetingMutation, CreateMeetingMutationVariables>;

/**
 * __useCreateMeetingMutation__
 *
 * To run a mutation, you first call `useCreateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeetingMutation, { data, loading, error }] = useCreateMeetingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<CreateMeetingMutation, CreateMeetingMutationVariables>) {
        return Apollo.useMutation<CreateMeetingMutation, CreateMeetingMutationVariables>(CreateMeetingDocument, baseOptions);
      }
export type CreateMeetingMutationHookResult = ReturnType<typeof useCreateMeetingMutation>;
export type CreateMeetingMutationResult = Apollo.MutationResult<CreateMeetingMutation>;
export type CreateMeetingMutationOptions = Apollo.BaseMutationOptions<CreateMeetingMutation, CreateMeetingMutationVariables>;
export const UpdateMeetingDocument = gql`
    mutation updateMeeting($id: Int!, $input: TerminUpdateInput!) {
  updateMeeting(id: $id, input: $input) {
    ...TerminFields
  }
}
    ${TerminFieldsFragmentDoc}`;
export type UpdateMeetingMutationFn = Apollo.MutationFunction<UpdateMeetingMutation, UpdateMeetingMutationVariables>;

/**
 * __useUpdateMeetingMutation__
 *
 * To run a mutation, you first call `useUpdateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeetingMutation, { data, loading, error }] = useUpdateMeetingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeetingMutation, UpdateMeetingMutationVariables>) {
        return Apollo.useMutation<UpdateMeetingMutation, UpdateMeetingMutationVariables>(UpdateMeetingDocument, baseOptions);
      }
export type UpdateMeetingMutationHookResult = ReturnType<typeof useUpdateMeetingMutation>;
export type UpdateMeetingMutationResult = Apollo.MutationResult<UpdateMeetingMutation>;
export type UpdateMeetingMutationOptions = Apollo.BaseMutationOptions<UpdateMeetingMutation, UpdateMeetingMutationVariables>;
export const RequestChatTokenDocument = gql`
    mutation requestChatToken($partId: Int!, $uuid: String!) {
  requestChatToken(partId: $partId, uuid: $uuid)
}
    `;
export type RequestChatTokenMutationFn = Apollo.MutationFunction<RequestChatTokenMutation, RequestChatTokenMutationVariables>;

/**
 * __useRequestChatTokenMutation__
 *
 * To run a mutation, you first call `useRequestChatTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestChatTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestChatTokenMutation, { data, loading, error }] = useRequestChatTokenMutation({
 *   variables: {
 *      partId: // value for 'partId'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useRequestChatTokenMutation(baseOptions?: Apollo.MutationHookOptions<RequestChatTokenMutation, RequestChatTokenMutationVariables>) {
        return Apollo.useMutation<RequestChatTokenMutation, RequestChatTokenMutationVariables>(RequestChatTokenDocument, baseOptions);
      }
export type RequestChatTokenMutationHookResult = ReturnType<typeof useRequestChatTokenMutation>;
export type RequestChatTokenMutationResult = Apollo.MutationResult<RequestChatTokenMutation>;
export type RequestChatTokenMutationOptions = Apollo.BaseMutationOptions<RequestChatTokenMutation, RequestChatTokenMutationVariables>;
export const FindMeetingDocument = gql`
    query findMeeting($uuid: String!) {
  meeting(uuid: $uuid) {
    ...TerminFields
  }
}
    ${TerminFieldsFragmentDoc}`;

/**
 * __useFindMeetingQuery__
 *
 * To run a query within a React component, call `useFindMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMeetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMeetingQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useFindMeetingQuery(baseOptions: Apollo.QueryHookOptions<FindMeetingQuery, FindMeetingQueryVariables>) {
        return Apollo.useQuery<FindMeetingQuery, FindMeetingQueryVariables>(FindMeetingDocument, baseOptions);
      }
export function useFindMeetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMeetingQuery, FindMeetingQueryVariables>) {
          return Apollo.useLazyQuery<FindMeetingQuery, FindMeetingQueryVariables>(FindMeetingDocument, baseOptions);
        }
export type FindMeetingQueryHookResult = ReturnType<typeof useFindMeetingQuery>;
export type FindMeetingLazyQueryHookResult = ReturnType<typeof useFindMeetingLazyQuery>;
export type FindMeetingQueryResult = Apollo.QueryResult<FindMeetingQuery, FindMeetingQueryVariables>;
export const CurrentParticipantDocument = gql`
    query currentParticipant($expoCode: String!) {
  participant(expoCode: $expoCode, currentUser: true) {
    ...ParticipantFields
  }
}
    ${ParticipantFieldsFragmentDoc}`;

/**
 * __useCurrentParticipantQuery__
 *
 * To run a query within a React component, call `useCurrentParticipantQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentParticipantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentParticipantQuery({
 *   variables: {
 *      expoCode: // value for 'expoCode'
 *   },
 * });
 */
export function useCurrentParticipantQuery(baseOptions: Apollo.QueryHookOptions<CurrentParticipantQuery, CurrentParticipantQueryVariables>) {
        return Apollo.useQuery<CurrentParticipantQuery, CurrentParticipantQueryVariables>(CurrentParticipantDocument, baseOptions);
      }
export function useCurrentParticipantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentParticipantQuery, CurrentParticipantQueryVariables>) {
          return Apollo.useLazyQuery<CurrentParticipantQuery, CurrentParticipantQueryVariables>(CurrentParticipantDocument, baseOptions);
        }
export type CurrentParticipantQueryHookResult = ReturnType<typeof useCurrentParticipantQuery>;
export type CurrentParticipantLazyQueryHookResult = ReturnType<typeof useCurrentParticipantLazyQuery>;
export type CurrentParticipantQueryResult = Apollo.QueryResult<CurrentParticipantQuery, CurrentParticipantQueryVariables>;